import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./phoneNumber.scss";
import { FormLabel } from "react-bootstrap";
const PhoneNumber = ({
  country,
  placeholder,
  value,
  required = false,
  onChange,
  ...res
}) => {
  return (
    <div className="phoneNumber">
      <FormLabel htmlFor="email" className="formLabel">
        Phone {required ? <span style={{ color: "red" }}>*</span> : ""}
      </FormLabel>
      <PhoneInput
        country={country}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default PhoneNumber;
